"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var __1 = require("../..");

require("./SzCardRadio.scss");

var SzCardRadio = function SzCardRadio(_a) {
  var checked = _a.checked,
      className = _a.className,
      label = _a.label,
      value = _a.value,
      name = _a.name,
      onChange = _a.onChange,
      id = _a.id,
      children = _a.children;
  var targetRef = react_1.useRef(null);

  var onClick = function onClick() {
    if (targetRef.current) {
      targetRef.current.click();
    }
  };

  var cardClasses = classnames_1.default('card-radio rounded-lg cursor-pointer', {
    'border-primary-brand': checked
  }, className);
  var contentClasses = classnames_1.default('p-4');
  var headerClasses = classnames_1.default('m-0 p-3 d-flex rounded-header', {
    'bg-primary-brand-light': checked,
    'bg-card-disabled-light': !checked
  });
  return react_1.default.createElement("div", {
    className: cardClasses,
    onClick: onClick
  }, react_1.default.createElement("div", {
    className: headerClasses
  }, label && react_1.default.createElement(__1.SzRadio, {
    name: name,
    label: label,
    checked: checked,
    value: value,
    id: id,
    onChange: onChange,
    ref: targetRef
  })), react_1.default.createElement("div", {
    className: contentClasses
  }, children));
};

exports.default = SzCardRadio;